import { createSelector } from 'reselect';
import I18n from '../../lib/i18n';
import TrpcLibrary from 'digicel-kaizen-library/lib/tripica-library';

const formatTimeline = timeline => {
  const timelineFiltered = timeline.filter(event => I18n.has(`timeline.${event.type}`));
  return TrpcLibrary.formattedTimeline(timelineFiltered);
};

export const timelineSelector = createSelector(
  state => state.timeline,
  timeline => formatTimeline(timeline)
);
